import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { PreflightRequest, PreflightResponse } from './types';

const PLUGIN_ID = 'panda';
const ERROR_DETAIL_MAX_LENGTH = 200;

export const runPreflightCheck = async (
  discovery: DiscoveryApi,
  fetchApi: FetchApi,
  request: PreflightRequest,
): Promise<PreflightResponse> => {
  const base = await discovery.getBaseUrl(PLUGIN_ID);
  const response = await fetchApi.fetch(`${base}/preflight/check`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(
      `Preflight check failed (HTTP ${response.status}): ${text.slice(
        0,
        ERROR_DETAIL_MAX_LENGTH,
      )}`,
    );
  }
  return (await response.json()) as PreflightResponse;
};
